import { useState } from "react";
import api, { MAD, apiError } from "../lib/api";
import { useData } from "../hooks/useData";
import { Link2 } from "lucide-react";
import { toast } from "sonner";

const fmtD = (s) => (s ? new Date(s).toLocaleDateString("fr-FR") : "—");

export function Rattachements({ onDone }) {
  const { data: rows, loading, refetch } = useData("/finance/rattachements");
  const [sel, setSel] = useState({});
  const [sync, setSync] = useState({});
  const toggle = (id) => setSel({ ...sel, [id]: !sel[id] });
  const supprimer = async (r) => {
    if (!window.confirm(`Supprimer définitivement la ligne provisoire « ${r.libelle} » (${MAD(r.montant)}) ? Le paiement réel (${MAD(r.montant_paiement)}) reste sur la fiche salarié.`)) return;
    try { await api.delete(`/expenses/${r.expense_id}`); toast.success("Ligne provisoire supprimée"); refetch(); onDone && onDone(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const nb = Object.values(sel).filter(Boolean).length;

  const valider = async () => {
    const items = rows.filter((r) => sel[r.expense_id] && r.action !== "supprimer_doublon").map((r) => ({
      expense_id: r.expense_id, charge_id: r.charge_id, salary_payment_id: r.salary_payment_id || "",
      sync_montant: !!(r.salary_payment_id && sync[r.expense_id]),
    }));
    if (!items.length) return toast.error("Cochez au moins un rattachement");
    if (!window.confirm(`Enregistrer ${items.length} rattachement(s) ? Les dépenses cochées sortiront des coûts variables.`)) return;
    try { const { data } = await api.post("/finance/rattachements/valider", { items }); toast.success(`${data.rattachees} dépense(s) rattachée(s)`); setSel({}); refetch(); onDone && onDone(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  if (loading) return null;
  return (
    <div data-testid="rattachements">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <p className="text-sm text-[var(--tm-muted)] max-w-2xl">Dépenses déjà saisies qui semblent correspondre à une charge fixe (salaire, avance, loyer…). Rien n'est enregistré tant que vous ne validez pas.</p>
        <button className="tm-btn tm-btn-gold" onClick={valider} disabled={!nb} data-testid="rattachements-valider"><Link2 size={15} /> Valider {nb || ""} rattachement(s)</button>
      </div>
      {rows.length === 0 ? <p className="text-sm text-[var(--tm-muted)]">Aucune proposition : toutes les dépenses de charges fixes sont rattachées.</p> : (
        <div className="tm-card overflow-x-auto">
          <table className="tm-table">
            <thead><tr><th></th><th>Date</th><th>Dépense</th><th className="text-right">Montant</th><th>Charge fixe proposée</th><th>Raison</th><th>Paiement salaire</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.expense_id} data-testid={`rattachement-row-${r.expense_id}`}>
                  <td>{r.action === "supprimer_doublon"
                    ? <button className="text-xs font-semibold" style={{ color: "#F44336" }} onClick={() => supprimer(r)} data-testid={`rattachement-delete-${r.expense_id}`}>Supprimer</button>
                    : <input type="checkbox" checked={!!sel[r.expense_id]} onChange={() => toggle(r.expense_id)} data-testid={`rattachement-check-${r.expense_id}`} />}</td>
                  <td className="whitespace-nowrap text-[var(--tm-muted)]">{fmtD(r.date)}</td>
                  <td className="font-semibold">{r.libelle}<span className="block text-[11px] font-normal text-[var(--tm-muted)]">{r.categorie}</span></td>
                  <td className="text-right tabular">{MAD(r.montant)}</td>
                  <td style={{ color: "var(--tm-gold)" }}>{r.charge_nom}</td>
                  <td className="text-xs text-[var(--tm-muted)] max-w-[260px]">{r.raison}</td>
                  <td className="text-xs">{r.action === "supprimer_doublon" ? <span style={{ color: "#F44336" }}>doublon de {MAD(r.montant_paiement)}</span> : r.salary_payment_id ? (
                    <label className="flex items-center gap-1.5"><input type="checkbox" checked={!!sync[r.expense_id]} onChange={() => setSync({ ...sync, [r.expense_id]: !sync[r.expense_id] })} data-testid={`rattachement-sync-${r.expense_id}`} />
                      lier au paiement {MAD(r.montant_paiement)}{r.montant_paiement !== r.montant ? " et corriger le montant" : ""}</label>
                  ) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
